// extracted by mini-css-extract-plugin
export default {"col_1000":"index_col_1000_5Q5xG","adbottom":"index_adbottom_OPwHn"};